import _ from 'lodash';

export default {
    data() {
        return {
            screenWidth: 0,
            isMobile: false,
            isScreenLowerThanDesktop: false,
        };
    },
    mounted() {
        this.updateScreenDimensions();
        window.addEventListener('resize', _.throttle(this.updateScreenDimensions, 500));
    },
    unmounted() {
        window.removeEventListener('resize', _.throttle(this.updateScreenDimensions, 500));
    },
};
